import React, { useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { getChannelRecentVideos } from "../YoutubeApi";
import "../css/components/RecentVideos.scss";
import { useNavigate } from "react-router-dom";

const RecentVideos = ({ channelId }) => {
  const VIDEO_AMOUNT = 4;
  const [videoArray, setVideoArray] = useState([
    {
      kind: "youtube#searchResult",
      etag: "frq_EXW5YWxa2XJhEndVC0R9z7s",
      id: {
        kind: "youtube#video",
        videoId: "EXqstawvwpo",
      },
      snippet: {
        publishedAt: "2023-01-25T03:00:08Z",
        channelId: "UCNhofiqfw5nl-NeDJkXtPvw",
        title: "구름에 가려진 신비의 베트남 산골도시 【베트남3】",
        description: "아오바오시의 연락 기다리겠습니다. -------------------------------------- 카메라 Gopro11 Galaxy S21 Insta360 ...",
        thumbnails: {
          default: {
            url: "https://i.ytimg.com/vi/EXqstawvwpo/default.jpg",
            width: 120,
            height: 90,
          },
          medium: {
            url: "https://i.ytimg.com/vi/EXqstawvwpo/mqdefault.jpg",
            width: 320,
            height: 180,
          },
          high: {
            url: "https://i.ytimg.com/vi/EXqstawvwpo/hqdefault.jpg",
            width: 480,
            height: 360,
          },
        },
        channelTitle: "빠니보틀 Pani Bottle",
        liveBroadcastContent: "none",
        publishTime: "2023-01-25T03:00:08Z",
      },
    },
    {
      kind: "youtube#searchResult",
      etag: "crtvgciaLm-GPNkb2VmTc8LEUy4",
      id: {
        kind: "youtube#video",
        videoId: "RxEcIuZEypE",
      },
      snippet: {
        publishedAt: "2023-01-20T12:27:02Z",
        channelId: "UCNhofiqfw5nl-NeDJkXtPvw",
        title: "낭만 가득 베트남 스쿠터 여행 【베트남2】",
        description: "공산당 아닙니다 -------------------------------------- 카메라 Gopro10 Galaxy S21 Insta360 -------------------------------------- 배경음악 Jahzzar ...",
        thumbnails: {
          default: {
            url: "https://i.ytimg.com/vi/RxEcIuZEypE/default.jpg",
            width: 120,
            height: 90,
          },
          medium: {
            url: "https://i.ytimg.com/vi/RxEcIuZEypE/mqdefault.jpg",
            width: 320,
            height: 180,
          },
          high: {
            url: "https://i.ytimg.com/vi/RxEcIuZEypE/hqdefault.jpg",
            width: 480,
            height: 360,
          },
        },
        channelTitle: "빠니보틀 Pani Bottle",
        liveBroadcastContent: "none",
        publishTime: "2023-01-20T12:27:02Z",
      },
    },
    {
      kind: "youtube#searchResult",
      etag: "YGz9z9-2Vkyr3K6ZaMe7RlsXru4",
      id: {
        kind: "youtube#video",
        videoId: "QYGJ-Zcma4Q",
      },
      snippet: {
        publishedAt: "2023-01-17T04:24:48Z",
        channelId: "UCNhofiqfw5nl-NeDJkXtPvw",
        title: "탈모와 뚱보와 털보의 여행기 【베트남1】",
        description: "본 컨텐츠는 여기어때의 지원을 받아서 제작되었습니다. -------------------------------------- 안녕하세요. 빠니보틀입니다. 제가 돌아 ...",
        thumbnails: {
          default: {
            url: "https://i.ytimg.com/vi/QYGJ-Zcma4Q/default.jpg",
            width: 120,
            height: 90,
          },
          medium: {
            url: "https://i.ytimg.com/vi/QYGJ-Zcma4Q/mqdefault.jpg",
            width: 320,
            height: 180,
          },
          high: {
            url: "https://i.ytimg.com/vi/QYGJ-Zcma4Q/hqdefault.jpg",
            width: 480,
            height: 360,
          },
        },
        channelTitle: "빠니보틀 Pani Bottle",
        liveBroadcastContent: "none",
        publishTime: "2023-01-17T04:24:48Z",
      },
    },
    {
      kind: "youtube#searchResult",
      etag: "Co6k_EJhCtIMQ5wzKD2cK23oBOE",
      id: {
        kind: "youtube#video",
        videoId: "RDtbyOKwbmw",
      },
      snippet: {
        publishedAt: "2022-12-06T12:30:37Z",
        channelId: "UCNhofiqfw5nl-NeDJkXtPvw",
        title: "기안84 세계여행 1:1 상담",
        description: "2022.12.11 MBC 첫 방송. -------------------------------------- 카메라 Gopro11 -------------------------------------- 배경음악 Kevin MacLeod - Fig ...",
        thumbnails: {
          default: {
            url: "https://i.ytimg.com/vi/RDtbyOKwbmw/default.jpg",
            width: 120,
            height: 90,
          },
          medium: {
            url: "https://i.ytimg.com/vi/RDtbyOKwbmw/mqdefault.jpg",
            width: 320,
            height: 180,
          },
          high: {
            url: "https://i.ytimg.com/vi/RDtbyOKwbmw/hqdefault.jpg",
            width: 480,
            height: 360,
          },
        },
        channelTitle: "빠니보틀 Pani Bottle",
        liveBroadcastContent: "none",
        publishTime: "2022-12-06T12:30:37Z",
      },
    },
  ]);

  const YOUTUBE_URL = "https://www.youtube.com/watch?v=";
  const navigate = useNavigate();

  //   useEffect(() => {
  //     (async () => {
  //       const recentVideoData = await getChannelRecentVideos(channelId, VIDEO_AMOUNT);
  //       setVideoArray([...recentVideoData]);
  //       console.log(videoArray);
  //     })();
  //   }, []);

  return (
    <ul className="recentVideoList">
      {videoArray?.length ? (
        videoArray.map((video) => {
          console.log(video, "video");
          return (
            <li key={video.id.videoId} className="item">
              <a href={`${YOUTUBE_URL}${video.id.videoId}`}>
                <img src={video.snippet.thumbnails.medium.url} alt="" />
                {/* <ReactPlayer className="videoPlayer" url={`https://www.youtube.com/embed/${video.id.videoId}&origin=http://localhost:3000/`} muted={false} playing={false} width="100%" height="100%" /> */}
                <p>{video.snippet.title}</p>
              </a>
            </li>
          );
        })
      ) : (
        <div>채널에 동영상이 존재하지 않습니다.</div>
      )}
    </ul>
  );
};

export default RecentVideos;
